module.exports = __webpack_public_path__ + "static/img/c6d0913.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/jbmzlsq/button.png
// module id = 641
// module chunks = 2